<form [formGroup]="rangeForm">
   <div class="flex flex-column gap-2">
      <div class="flex gap-2">
         <p-inputNumber
            type="number"
            formControlName="min"
            [min]="rangeFilter?.min || 0"
            [max]="rangeFilter?.max || 1000"
            class="w-full md:w-40"
            placeholder="Min"
            mode="currency"
            currency="EUR"
            [showButtons]="true"
         />
         <p-inputNumber
            type="number"
            formControlName="max"
            [min]="rangeFilter?.min || 0"
            [max]="rangeFilter?.max || 1000"
            class="w-full md:w-40"
            placeholder="Max"
            mode="currency"
            currency="EUR"
            [showButtons]="true"
         />
      </div>

      <div *ngIf="rangeForm.errors?.['rangeInvalid']" class="text-red-700">
         {{ 'DATA.COMMON.FORM.ERROR.RANGE_INVALID' | translate }}
      </div>
   </div>
</form>
